import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WithLazyLoadBreakingNews from 'modules/WithBreakingNews/WithLazyLoadBreakingNews';
import throttle from 'lodash.throttle';
import { inViewForReact } from 'utils/common';
import TopBar from './TopBar/TopBar';
import Navigation from './Navigation/Navigation';
import Masthead from './Masthead/Masthead';
import NavList from '../../common/NavList/NavList';

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      stickyHeader: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.monitorScroll());
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.monitorScroll());
  }

  monitorScroll = () => throttle(this.handleScrollEvent, 100);

  handleScrollEvent = () => {
    let stickyHeader = false;
    const elem =
      document.getElementById('header-masthead') ||
      document.getElementById('top-bar-container');

    if (elem && !inViewForReact(elem, 0, true)) {
      stickyHeader = true;
    }
    const refreshButton = document.getElementById('refresh-button');
    if (refreshButton && stickyHeader) {
      refreshButton.classList.add('sticky');
    } else if (refreshButton && !stickyHeader) {
      refreshButton.classList.remove('sticky');
    }
    window.isStickyHeader = stickyHeader;
    this.setState({ stickyHeader });
  };

  render() {
    const {
      headerData = {},
      hideCyclicNav,
      showWeatherInC,
      enablePrimeFlow,
      isPrime,
      hideLogoMastHead,
      showToiPlusEntryPoints,
      headerNavData,
      layoutType,
      translationData,
      toipLayout,
      isAffiliatePage,
      isPrimeUserLayout,
      isReviewsPage,
    } = this.props;
    const {
      navigation,
      masthead,
      videomasthead,
      hideTimeStamp,
      promotionalL2,
    } = headerData;
    let navigationmenu = navigation;
    // console.log("typeof",typeof headerDatas);
    if (headerNavData && typeof headerNavData === 'object') {
      navigationmenu = headerNavData;
    }
    const isMastheadToiLogo = masthead && masthead.type === 'toiLogo';
    const theme = headerData.colorTheme || this.props.colorTheme;
    //const navPath = this.props.params[0].split('/');
    let isSpeakingtree = false;

    if (
      (this.props.newsData &&
        this.props.newsData.navsubsecs &&
        this.props.newsData.navsubsecs.subsec1 &&
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '106291237') ||
      (this.props.pageType === 'ARTICLESHOW' &&
        this.props.subSecSeoLocation === 'speaking-tree')
    ) {
      isSpeakingtree = true;
    } else {
      isSpeakingtree = false;
    }

    let isTechnology = false;

    if (
      this.props.newsData &&
      this.props.newsData.navsubsecs &&
      this.props.newsData.navsubsecs.subsec1 &&
      (this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '106755835' ||
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '100699880' ||
        this.props.newsData.navsubsecs.subsec1.subsecmsid1 === '66949542')
    ) {
      isTechnology = true;
    } else if (
      this.props.articleSectionData &&
      this.props.msid &&
      this.props.articleSectionData[this.props.msid] &&
      this.props.articleSectionData[this.props.msid].navsubsecs &&
      this.props.articleSectionData[this.props.msid].navsubsecs.subsec1 &&
      (this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
        .subsecmsid1 === '106755835' ||
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
          .subsecmsid1 === '100699880' ||
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec1
          .subsecmsid1 === '66949542')
    ) {
      isTechnology = true;
    } else {
      isTechnology = false;
    }

    if (
      (this.props.newsData &&
        this.props.newsData.navsubsecs &&
        this.props.newsData.navsubsecs.subsec2 &&
        this.props.newsData.navsubsecs.subsec2.subsecmsid2 === '104313548') ||
      (this.props.articleSectionData &&
        this.props.msid &&
        this.props.articleSectionData[this.props.msid] &&
        this.props.articleSectionData[this.props.msid].navsubsecs &&
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec2 &&
        this.props.articleSectionData[this.props.msid].navsubsecs.subsec2
          .subsecmsid2 === '104313548')
    ) {
      isTechnology = false;
    }

    let toiLogoUrl = '/';
    if (
      headerData &&
      navigation &&
      navigation.home &&
      typeof navigation.home === 'object' &&
      navigation.home.label &&
      typeof navigation.home.label === 'string' &&
      navigation.home.label.toLowerCase() === 'home' &&
      navigation.home.link &&
      navigation.home.link !== '/'
    ) {
      toiLogoUrl = navigation.home.link;
    }

    return (
      <div
        className={classNames({
          'header-container': true,
          contentwrapper: !this.props.toipLayout,
          // this.props.pageType !== 'toiplusplanpage'
          contentwrapper_prime: this.props.isPrimeUserLayout,
        })}
      >
        {}
        <div className="popupWrapperSecond" />
        <TopBar
          isWapView={this.props.isWapView}
          hideTimeStamp={hideTimeStamp}
          editionSwitch={this.props.headerData?.editionSwitch}
          hideTimesPointPopup={this.props.hideTimesPointPopup}
          isPrime={isPrime}
          colorTheme={theme}
          showWeatherInC={showWeatherInC}
          enablePrimeFlow={enablePrimeFlow}
          pageType={this.props.pageType}
          showToiPlusEntryPoints={showToiPlusEntryPoints}
          disableTimesPointWidget={this.props.disableTimesPointWidget}
          translationData={translationData}
          toipLayout={toipLayout}
          showPollutionInfo={this.props.showPollutionInfo}
          TOILogoUrl={toiLogoUrl}
          isAffiliatePage={isAffiliatePage}
          msid={this.props.msid}
          articleSectionData={this.props.articleSectionData}
          newsData={this.props.newsData}
          liveblogData={this.props.liveblogData}
          enableCityChangeFeature={this.props.enableCityChangeFeature}
          layoutType={layoutType}
          storyTitle={this.props.storyTitle}
          isTechnology={isTechnology}
          isPrimeUserLayout={isPrimeUserLayout}
          isReviewsPage={isReviewsPage}
          skipReloadForPrimeLogin={this.props.skipReloadForPrimeLogin}
        />
        {(masthead || videomasthead) &&
          this.props.pageType !== 'ARTICLESHOW' &&
          !toipLayout && (
            <Masthead
              config={masthead}
              videomasthead={isPrime ? {} : videomasthead}
              colorTheme={theme}
              poweredBy={headerData.poweredBy}
              hideLogoMastHead={hideLogoMastHead}
              TOILogoUrl={toiLogoUrl}
              isPrime={isPrime}
              isTechnology={isTechnology}
              mastheadImageLogo={this.props.mastheadImageLogo}
              isPrimeUserLayout={isPrimeUserLayout}
              isReviewsPage={isReviewsPage}
            />
          )}

        {isSpeakingtree && (
          <div className="only_st_logo">
            <img src="https://static.toiimg.com/photo/107819150.cms" alt="" />
          </div>
        )}
        <Navigation
          hideCyclicNav={hideCyclicNav}
          l2navigationChild={this.props.l2navigationChild}
          allMenu={headerData.allMenu}
          colorTheme={theme}
          forSelectedL2Link={this.props.forSelectedL2Link}
          navigationData={layoutType !== 'primeshow' ? navigationmenu : null}
          isWapView={this.props.isWapView}
          stickyHeader={this.state.stickyHeader}
          showHomeOnlyWhenSticky={isMastheadToiLogo}
          pageType={this.props.pageType}
          geolocation={this.props.geolocation}
          showToiPlusEntryPoints={showToiPlusEntryPoints}
          toipLayout={toipLayout}
          userData={this.props.userData}
          isPrime={isPrime}
          toiAssistNavEnabled={this.props.toiAssistNavEnabled}
          isPrimeUserLayout={isPrimeUserLayout}
          hideTodaysEpaperButton={isReviewsPage}
        />
        {promotionalL2 && (
          <div
            className={`contentwrapper ${this.props.l2OverrideWrapperClass ||
              ''} ${
              this.props.isPrimeUserLayout ? 'contentwrapper_prime' : ''
            }`}
          >
            <NavList data={promotionalL2} hideLabel={this.props.hideL2Label} />
          </div>
        )}
        {!toipLayout && (
          <WithLazyLoadBreakingNews theme="redTheme" addWrapper withClose />
        )}
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   navigationData: state.header.data,
// });

Header.propTypes = {
  hideCyclicNav: PropTypes.bool,
  l2navigationChild: PropTypes.shape({}),
  promotionalL2: PropTypes.shape({}),
  headerData: PropTypes.shape({
    editionSwitch: PropTypes.shape({}),
  }).isRequired,
  isWapView: PropTypes.bool.isRequired,
  hideTimesPointPopup: PropTypes.bool,
  showWeatherInC: PropTypes.bool,
  enablePrimeFlow: PropTypes.bool,
  pageType: PropTypes.string,
  layoutType: PropTypes.string,
  geolocation: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  hideLogoMastHead: PropTypes.bool,
  colorTheme: PropTypes.string,
  disableTimesPointWidget: PropTypes.string,
  headerNavData: PropTypes.shape({}),
  userData: PropTypes.shape({}),
  toipLayout: PropTypes.bool,
  isAffiliatePage: PropTypes.bool,
  enableCityChangeFeature: PropTypes.bool,
  storyTitle: PropTypes.string,
  hideL2Label: PropTypes.bool,
  l2OverrideWrapperClass: PropTypes.string,
  isPrimeUserLayout: PropTypes.bool,
};

Header.defaultProps = {
  hideCyclicNav: false,
  l2navigationChild: null,
  hideTimesPointPopup: false,
  promotionalL2: { items: [] },
  showWeatherInC: false,
  enablePrimeFlow: false,
  pageType: '',
  geolocation: '1',
  showToiPlusEntryPoints: false,
  hideLogoMastHead: false,
  colorTheme: '',
  disableTimesPointWidget: false,
  headerNavData: undefined,
  userData: undefined,
  layoutType: '',
  toipLayout: false,
  isAffiliatePage: false,
  enableCityChangeFeature: false,
  storyTitle: '',
  hideL2Label: false,
  l2OverrideWrapperClass: '',
  isPrimeUserLayout: false,
};

export default Header;
